export default function FormLabel({label}) {
  return <label className="color-light-blue mb-2"><b>{label}</b></label>
}
